// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"41739f1e","453":"d0a5faf1","498":"52102433","551":"16c93a2e","617":"5fce26e2","677":"ae2b93c7","842":"9b9baeef","904":"f185e7f5"}[chunkId] + ".chunk.js";
};